import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IExperiment } from '../model/experiment/Experiment';
import type { IExperimentSearchParams } from '../api/requests/ExperimentApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

export interface useExperimentsResult {
    isLoaded: boolean;
    experiments: IExperiment[] | null;
}

export const useExperiments = (searchParams: IExperimentSearchParams) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useExperimentsResult>({ isLoaded: false, experiments: [] });

    useEffect(() => {
        setResult({ isLoaded: false, experiments: [] });

        rootStore.experimentStore.loadExperiments(searchParams)
            .then(() => {
                if (searchParams.statuses?.length === 0)
                    setResult({ isLoaded: true, experiments: [] });
                else
                    setResult({ isLoaded: true, experiments: rootStore.experimentStore.experiments });
            })
            .catch(e => publishNotification({
                text: `Error loading experiments: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.experimentStore, publishNotification, searchParams, rootStore.gameVersionStore.currentGameVersion, rootStore.gameEnvironmentsStore.currentGameEnvironment]);

    return result;
};
